import { Component } from '@angular/core';
import { clsx } from 'clsx';

@Component({
  selector: 'stat-summary-block',
  template: `<ng-content />`,
  host: {
    '[class]': 'hostClasses',
  },
})
export class StatSummaryBlockComponent {
  hostClasses = clsx('flex flex-1 flex-col items-center gap-md px-md py-xl text-center');
}
